import { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { FgtsManutation } from "./manutation";
import { FgtsErrorLogsPanel } from "./errorlogs";
import { FgtsProviderOrderPanel } from "./providerorder";
import { FgtsConsultsPanel } from "./consults";

export function FgtsAdm(){
    const [tab, setTab] = useState(0);
    return (<div>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto" centered>
                <Tab label="Configurações" />
                <Tab label="Ordem dos bancos" />
                <Tab label="Consultas" />
                <Tab label="Logs de erro" />
            </Tabs>
        </Box>

        {tab === 0 && <FgtsManutation/>}
        {tab === 1 && <FgtsProviderOrderPanel/>}
        {tab === 2 && <FgtsConsultsPanel/>}
        {tab === 3 && <FgtsErrorLogsPanel/>}
    </div>)
}
